export default __webpack_public_path__ + "3ds-max.d3961077.png";